const popup = function() {
  /**
   * Element.closest() polyfill
   * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
   */
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function(s) {
      const el = this;
      let ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }

  // Trap Focus
  // https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
  //
  function trapFocus(element) {
    const focusableEls = element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
    );
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];
    const KEYCODE_TAB = 9;

    element.addEventListener('keydown', e => {
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } /* tab */ else if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    });
  }

  //
  // Settings
  //
  const settings = {
    speedOpen: 50,
    speedClose: 250,
    activeClass: 'is-active',
    visibleClass: 'is-visible',
    selectorTarget: '[data-popup-target]',
    selectorTrigger: '[data-popup-trigger]',
    selectorClose: '[data-popup-close]',
  };

  //
  // Methods
  //

  // Toggle accessibility
  const toggleccessibility = function(event) {
    if (event.getAttribute('aria-expanded') === 'true') {
      event.setAttribute('aria-expanded', false);
    } else {
      event.setAttribute('aria-expanded', true);
    }
  };

  // Open Popup
  const openPopup = function(trigger) {
    // Find target
    const target = document.getElementById(
      trigger.getAttribute('aria-controls'),
    );

    // Make it active
    target.classList.add(settings.activeClass);

    // Make body overflow hidden so it's not scrollable
    document.documentElement.style.overflow = 'hidden';

    // Toggle accessibility
    toggleccessibility(trigger);

    // Make it visible
    setTimeout(() => {
      target.classList.add(settings.visibleClass);
      trapFocus(target);
    }, settings.speedOpen);
  };

  // Close Popup
  const closePopup = function(event) {
    // Find target
    const closestParent = event.closest(settings.selectorTarget);
    const childrenTrigger = document.querySelector(
      `[aria-controls="${closestParent.id}"`,
    );

    // Make it not visible
    closestParent.classList.remove(settings.visibleClass);

    // Remove body overflow hidden
    document.documentElement.style.overflow = '';

    // Toggle accessibility
    toggleccessibility(childrenTrigger);

    // Make it not active
    setTimeout(() => {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  // Click Handler
  const clickHandler = function(event) {
    // Find elements
    const toggle = event.target;
    const open = toggle.closest(settings.selectorTrigger);
    const close = toggle.closest(settings.selectorClose);

    // Open popup when the open button is clicked
    if (open) {
      openPopup(open);
    }

    // Close popup when the close button (or overlay area) is clicked
    if (close) {
      closePopup(close);
    }

    // Prevent default link behavior
    if (open || close) {
      event.preventDefault();
    }
  };

  // Keydown Handler, handle Escape button
  const keydownHandler = function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      // Find all possible popups
      const popups = document.querySelectorAll(settings.selectorTarget);
      let i;

      // Find active popups and close them when escape is clicked
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < popups.length; ++i) {
        if (popups[i].classList.contains(settings.activeClass)) {
          closePopup(popups[i]);
        }
      }
    }
  };

  //
  // Inits & Event Listeners
  //
  document.addEventListener('click', clickHandler, false);
  document.addEventListener('keydown', keydownHandler, false);
};

popup();
